import React from 'react';
import { Redirect } from 'react-router-dom';
import { Tabs, Typography } from 'antd';
import { ROLES } from '_helpers/roles';
import { UsersTab } from './UsersTab';
import { ClassesTab } from './ClassesTab';
import { AcademicTab } from './AcademicTab';
import { SystemTab } from './SystemTab';
import { MaintenanceTab } from './MaintenanceTab';

export { PanelPage };

const { Title, Text } = Typography;
const { TabPane } = Tabs;

// Admin-only control panel. Backend independently gates every /api/admin/* route
// with validateAdmin — this client guard is just UX, not the security boundary.
function PanelPage() {
    const userData = JSON.parse(localStorage.getItem('userData') || '{}');
    if (userData.role !== ROLES.ADMIN) return <Redirect to="/" />;

    return (
        <div style={{ padding: 24, maxWidth: 1280, margin: '0 auto' }}>
            <Title level={3} style={{ marginBottom: 4 }}>Admin Panel</Title>
            <Text type="secondary">Quản trị hệ thống — chỉ dành cho admin.</Text>
            <Tabs defaultActiveKey="users" style={{ marginTop: 16 }}>
                <TabPane tab="Người dùng" key="users"><UsersTab /></TabPane>
                <TabPane tab="Lớp học" key="classes"><ClassesTab /></TabPane>
                <TabPane tab="Học vụ" key="academic"><AcademicTab /></TabPane>
                <TabPane tab="Hệ thống" key="system"><SystemTab /></TabPane>
                <TabPane tab="Bảo trì" key="maintenance"><MaintenanceTab /></TabPane>
            </Tabs>
        </div>
    );
}
